import { render } from "./minimal_select.vue?vue&type=template&id=70257444&scoped=true"
import script from "./minimal_select.vue?vue&type=script&lang=js"
export * from "./minimal_select.vue?vue&type=script&lang=js"

import "./minimal_select.vue?vue&type=style&index=0&id=70257444&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-70257444"

export default script